/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TIsOfferDealCandidateModel,
  IIsOfferDealCandidateRequest,
  IMappers,
  IIsOfferDealCandidateResponse,
  IIsOfferDealCandidateResponseError,
  TIsOfferDealCandidateResponse
} from "./types";

const defaultConfig: TIsOfferDealCandidateModel = {
  apiType: "public",
  assertStatusCodes: [200, 400],
  method: "GET",
  microserviceName: "deal-rent-announcements",
  pathApi: "/v1/is-offer-deal-candidate/",
  hostType: "api"
} as TIsOfferDealCandidateModel;

function createIsOfferDealCandidateModel(
  parameters: IIsOfferDealCandidateRequest
): TIsOfferDealCandidateModel {
  return {
    ...defaultConfig,
    parameters
  };
}

export interface IIsOfferDealCandidateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IIsOfferDealCandidateRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchIsOfferDealCandidate<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers
}: IIsOfferDealCandidateOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TIsOfferDealCandidateResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createIsOfferDealCandidateModel(parameters),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIsOfferDealCandidateResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IIsOfferDealCandidateResponseError);
    }
  }

  return { response, statusCode } as TIsOfferDealCandidateResponse;
}

export {
  defaultConfig,
  createIsOfferDealCandidateModel,
  fetchIsOfferDealCandidate
};
